export type TripBackupAuditPage = "backup" | "xar";

export type TripBackupAuditAction =
  | "download"
  | "dismiss"
  | "xarAwarenessDismiss"
  | "xarAwarenessNavigate";

export interface TripBackupAuditLog {
  accountId: string;
  action: TripBackupAuditAction;
  period?: "threeMonths" | "fiscalYear";
  pagesShown?: TripBackupAuditPage[];
  timestamp: string;
}

class AuditService {
  /**
   * Log trip backup reminder actions for audit purposes
   * This creates an audit trail of user interactions with the backup reminder
   */
  static logTripBackupAction = async (data: TripBackupAuditLog) => {
    try {
      // Send to backend audit endpoint
      // Uncomment when backend endpoint is ready
      // return await axiosInstance.post(`/audit/trip-backup-reminder`, data);

      // For now, store in sessionStorage as a fallback
      const existingLogs = sessionStorage.getItem("trip_backup_audit_logs");
      const logs = existingLogs ? JSON.parse(existingLogs) : [];

      logs.push({
        ...data,
        userAgent: navigator.userAgent,
        browserTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone
      });

      // Keep only last 100 logs to prevent storage overflow
      if (logs.length > 100) {
        logs.shift();
      }

      sessionStorage.setItem("trip_backup_audit_logs", JSON.stringify(logs));

      return { success: true };
    } catch (error) {
      console.error("Error logging trip backup audit action:", error);
      // Don't throw - we don't want audit logging failures to break the user flow
      return { success: false, error };
    }
  };

  /**
   * Get audit logs from session storage (for debugging/testing)
   */
  static getTripBackupAuditLogs = (): TripBackupAuditLog[] => {
    try {
      const logs = sessionStorage.getItem("trip_backup_audit_logs");
      return logs ? JSON.parse(logs) : [];
    } catch {
      return [];
    }
  };

  /**
   * Clear audit logs from session storage
   */
  static clearTripBackupAuditLogs = (): void => {
    sessionStorage.removeItem("trip_backup_audit_logs");
  };
}

export default AuditService;
